import React from 'react';
import { clsx } from 'clsx';
import { resolveSourceVisual } from './intelVisualConfig';

type Props = {
    source?: string | null;
    showLabel?: boolean;
    className?: string;
};

export const SourceMark: React.FC<Props> = ({ source, showLabel = true, className }) => {
    const visual = resolveSourceVisual(source);
    const monogram = visual.monogram ?? '??';

    return (
        <span className={clsx('inline-flex min-w-0 items-center gap-1.5', className)}>
            <span
                className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md border border-border bg-muted/60 text-[9px] font-bold uppercase tracking-tight text-muted-foreground"
                title={source || 'Unknown source'}
                aria-hidden
            >
                {monogram.length <= 2 ? monogram : monogram.slice(0, 2)}
            </span>
            {showLabel && (
                <span className="truncate text-[11px] text-muted-foreground">{source || 'Unknown'}</span>
            )}
        </span>
    );
};

/** Square monogram for merchant/trader names (P2P rows). */
export const ProviderMonogram: React.FC<{ name?: string | null; className?: string }> = ({
    name,
    className,
}) => {
    const letters = (name ?? '??').trim().slice(0, 2).toUpperCase() || '??';
    return (
        <span
            className={clsx(
                'inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-border bg-brand-ink text-[10px] font-bold uppercase text-white dark:bg-muted dark:text-foreground',
                className,
            )}
            aria-hidden
        >
            {letters}
        </span>
    );
};
